import { Avatar as e } from "../avatar/index.js";
import { Badge as t } from "../badge/index.js";
import { cn as n } from "../cn.js";
import { Card as r } from "./index.js";
import * as i from "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { When as s } from "react-if";
// src/design/card/presets.tsx
var c = (e) => ({
	Approved: {
		colorScheme: "success",
		icon: "Check",
		text: "Approved"
	},
	Pending: {
		colorScheme: "primary",
		icon: "CircleDotDashed",
		text: "Pending"
	},
	Cancelled: {
		colorScheme: "danger",
		icon: "Ban",
		text: "Cancelled"
	},
	Rejected: {
		colorScheme: "danger",
		icon: "X",
		text: "Rejected"
	},
	Request: {
		colorScheme: "default",
		icon: "Send",
		text: "Request"
	},
	Reviewed: {
		colorScheme: "primary",
		icon: "CircleDotDashed",
		text: "Reviewed"
	}
})[e], l = i.forwardRef(({ data: i, onClick: l, className: u, isFitWidth: d = !1 }, f) => {
	let { name: p, jobTitle: m, location: h, department: g, status: _, avatarSrc: v, avatarFallback: y, avatar: b } = i, x = _ ? c(_) : void 0;
	return /* @__PURE__ */ a(r, {
		ref: f,
		variant: "outlined",
		size: "md",
		fullWidth: !d,
		onClick: l,
		className: n("px-2.5 py-2", { "w-fit pr-8": d }, u),
		children: /* @__PURE__ */ a(r.Body, { children: /* @__PURE__ */ o("div", {
			className: "flex items-center gap-3",
			children: [b || /* @__PURE__ */ o(e.Root, {
				fallback: y || p,
				src: v,
				className: "w-10 h-10 rounded-full bg-muted flex items-center justify-center shrink-0",
				children: [v && /* @__PURE__ */ a(e.Image, {
					src: v,
					alt: p
				}), /* @__PURE__ */ a(e.Fallback, {
					className: "text-foreground font-semibold",
					children: y || p
				})]
			}), /* @__PURE__ */ o("div", {
				className: "flex-1 min-w-0",
				children: [
					/* @__PURE__ */ a("h3", {
						className: "text-base font-medium text-primary hover:text-primary-700 cursor-pointer",
						children: p
					}),
					/* @__PURE__ */ a("p", {
						className: "text-xs font-medium text-foreground",
						children: m
					}),
					/* @__PURE__ */ o("p", {
						className: "text-xs text-muted-foreground mb-2",
						children: [h, g?.trim().length ? `, ${g}` : ""]
					}),
					/* @__PURE__ */ a(s, {
						condition: x !== void 0,
						children: /* @__PURE__ */ a(t, {
							colorScheme: x?.colorScheme,
							size: "md",
							variant: "fill",
							icon: x?.icon,
							children: x?.text
						})
					})
				]
			})]
		}) })
	});
});
l.displayName = "EmployeeCard";
var u = i.forwardRef(({ title: e, note: t, actions: i, flush: s = !1, className: c, children: l }, u) => /* @__PURE__ */ o(r, {
	ref: u,
	size: "none",
	className: n("overflow-hidden", c),
	children: [/* @__PURE__ */ o(r.Header, {
		bordered: !0,
		spacing: "none",
		className: "gap-3 px-4 py-3",
		children: [/* @__PURE__ */ o("div", {
			className: "min-w-0 flex-1",
			children: [/* @__PURE__ */ a(r.Title, {
				size: "sm",
				as: "h2",
				children: e
			}), t !== void 0 && /* @__PURE__ */ a(r.Description, {
				size: "sm",
				children: t
			})]
		}), i && /* @__PURE__ */ a("div", {
			className: "flex shrink-0 items-center gap-2",
			children: i
		})]
	}), /* @__PURE__ */ a("div", {
		className: n(!s && "p-4"),
		children: l
	})]
}));
u.displayName = "SectionCard";
var d = {
	EmployeeCard: l,
	SectionCard: u
};
export { d as CardPresets, d as default, l as EmployeeCard, u as SectionCard };

//# sourceMappingURL=presets.js.map